import SnappySlider from "../../../../src/components/SnappySlider";
import SnappySlide from "../../../../src/components/SnappySlider/SnappySlide";
import Link from 'gatsby-link';
import * as React from 'react';
export default {
  SnappySlider,
  SnappySlide,
  Link,
  React
};